



















































































import { Component, Vue } from 'vue-property-decorator';
import {
  loadScreenSaversAction,
  updateScreenSaver,
  loadFallbackScreenSaversAction,
  updateFallbackScreenSaver,
} from '@adminSchedules/shared/actions';
import FormComponent from '@/app/shared/components/FormComponent.vue';
import CreateScreenSaver from '@/app/screens/App/screens/Admin/screens/Schedules/screens/ScreenSaver/components/CreateScreenSaver/CreateScreenSaver.vue';
import ScreenSaverList from '@/app/screens/App/screens/Admin/screens/Schedules/screens/ScreenSaver/components/ScreenSaverList/ScreenSaverList.vue';
import {
  DefaultScreenSaver,
  FallbackScreenSaver,
  ScreenSaverType,
} from '@/app/shared/utilities/static-types';

@Component({
  components: {
    FormComponent,
    CreateScreenSaver,
    ScreenSaverList,
  },
})
export default class ScreenSaver extends Vue {
  public showCreateScreenSaver = false;
  public showCreateFallbackScreenSaver = false;
  public screenSavers: DefaultScreenSaver[] = [];
  public fallbackScreenSavers: FallbackScreenSaver[] = [];
  public updateListFunction!: () => void;
  public updateFallbackListFunction!: () => void;

  public readonly screenSaverType = ScreenSaverType.SCREEN_SAVER;
  public readonly fallbackScreenSaverType = ScreenSaverType.FALLBACK_SCREEN_SAVER;

  public activeChanged(screenSaverId: string) {
    updateScreenSaver(
      this.screenSavers.find(
        (screenSaver) => screenSaver.ID === screenSaverId,
      ) as DefaultScreenSaver,
    );
  }

  public fallbackActiveChanged(screenSaverId: string) {
    updateFallbackScreenSaver(
      this.fallbackScreenSavers.find(
        (screenSaver) => screenSaver.ID === screenSaverId,
      ) as FallbackScreenSaver,
    );
  }

  public setUpdateListFunction(updateListFunction: () => void) {
    this.updateListFunction = updateListFunction;
  }

  public setFallbackUpdateListFunction(updateListFunction: () => void) {
    this.updateFallbackListFunction = updateListFunction;
  }

  public async updateScreenSaversList() {
    await this.loadScreenSavers();
    this.updateListFunction();
  }

  public async updateFallbackScreenSaversList() {
    await this.loadFallbackScreenSavers();
    this.updateFallbackListFunction();
  }

  public async loadAllScreenSavers() {
    await Promise.all([
      this.loadScreenSavers(),
      this.loadFallbackScreenSavers(),
    ]);
  }

  public async loadScreenSavers() {
    this.screenSavers = await loadScreenSaversAction();
  }

  public async loadFallbackScreenSavers() {
    this.fallbackScreenSavers = await loadFallbackScreenSaversAction();
  }
}
